import { useCallback, useMemo } from "react";

import type { QuestionType } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

export type UsePlanIsHiddenHotelQuestionsProps = {
	questions: {
		questionID: string;
		required?: boolean | null | undefined;
		questionType: QuestionType;
		question: string;
		options?: string[] | null | undefined;
	}[];
};

type Props = {
	questions: {
		questionID: string;
		required?: boolean | null | undefined;
		questionType: QuestionType;
		question: string;
		options?: string[] | null | undefined;
	}[];
	isHiddenHotelQuestions: ForNodeType<boolean>;

	onSetViewModel: (
		values: {
			key: "isHiddenHotelQuestions";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsHiddenHotelQuestions = ({
	questions: _questions,
	isHiddenHotelQuestions,
	onSetViewModel,
}: Props) => {
	const onSetIsHiddenHotelQuestions = useCallback(
		(value: boolean) => {
			onSetViewModel([
				{
					key: "isHiddenHotelQuestions",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const questions = useMemo(() => _questions, [_questions]);

	return {
		isHiddenHotelQuestions,
		onSetIsHiddenHotelQuestions,
		questions,
	};
};
